import { Route, Switch } from 'react-router';
import CaseloadsTransfer from './search';
import CaseloadsTransferStep2 from './transfer';

const CaseloadTransfer = () => {
  return (
    <Switch>
      <Route exact path='/caseloadTransfer/transfer' component={CaseloadsTransferStep2} />
      <Route exact path='/caseloadTransfer' component={CaseloadsTransfer} />
    </Switch>
  );
};

export default CaseloadTransfer;
